/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DOM_DELTA_PIXEL = 0;
const DOM_DELTA_LINE = 1;
const DOM_DELTA_PAGE = 2;
export function getWheelZoomAmount(event) {
    let multiplier = 0;
    let deltaMode = event.deltaMode;

    switch (deltaMode) {
        case DOM_DELTA_PIXEL:
            multiplier = 1 / 200.0;
            break;
        case DOM_DELTA_LINE:
            multiplier = 1 / 10.0;
            break;
        case DOM_DELTA_PAGE:
            multiplier = 2;
            break;
    }
    return Math.exp(event.deltaY * multiplier);
}
//# sourceMappingURL=wheel_zoom.js.map